import * as React from 'react';
import Stack from '@mui/material/Stack';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Box, IconButton, useTheme } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CustomTheme } from '../../../../types/customTheme/customTheme';
import configUrls from '../../../../config/configUrls';

function HomeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}

type HeaderSiteRedeSocialProps = {
  alignment?: 'flex-start' | 'flex-end';
}

export function HeaderSiteRedeSocial({ alignment }: HeaderSiteRedeSocialProps) {
  const theme = useTheme() as CustomTheme;

  const linkInstagram = theme.custom?.linkInstagram || 'https://instagram.com.br';

  const linkFacebook = theme.custom?.linkFacebook || 'https://facebook.com.br';

  const linkYoutube = theme.custom?.linkYoutube || 'https://youtube.com.br';

  const iconSize = theme.typography?.iconSize || '1.25rem';

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: alignment || 'flex-end',
        padding: 0
      }}
    >
      <Stack direction="row" spacing={2} padding={0}>
        <IconButton onClick={() => (window.location.href = configUrls.SITE_HOME)} title="Início">
          <HomeIcon sx={{ fontSize: iconSize, color: theme.palette.text.primary }} />
        </IconButton>

        <IconButton component="a" href={linkFacebook} target="_blank" rel="noopener" title="Facebook">
          <FacebookIcon sx={{ fontSize: iconSize, color: theme.palette.primary.main }} />
        </IconButton>

        <IconButton component="a" href={linkInstagram} target="_blank" rel="noopener" title="Instagram">
          <InstagramIcon sx={{ fontSize: iconSize, color: theme.palette.secondary.main }} />
        </IconButton>

        <IconButton component="a" href={linkYoutube} target="_blank" rel="noopener" title="YouTube">
          <YouTubeIcon
            sx={{
              fontSize: iconSize,
              color: theme.palette.error?.main || '#d32f2f'
            }}
          />
        </IconButton>
      </Stack>
    </Box>
  );
}
